import * as React from "react";
import { cn } from "./utils";

interface InputFieldsetProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  required?: boolean;
  leftIcon?: React.ReactNode;
}

const InputFieldset = React.forwardRef<
  HTMLInputElement,
  InputFieldsetProps
>(({ className, label, required, id, leftIcon, ...props }, ref) => {
  const generatedId = React.useId();
  const inputId = id ?? generatedId;

  return (
    <fieldset
      className={cn(
        "w-full",
        "rounded-[0.6rem]",
        "border-0",
        "bg-transparent",
        "px-3 pt-1 pb-2",
        "shadow-[inset_0_0_0_1px_rgba(0,0,0,0.1)]",
        "focus-within:shadow-[inset_0_0_0_1px_rgba(59,130,246,0.6),0_0_0_3px_rgba(59,130,246,0.25)]",
        "transition-all",
        className
      )}
    > 
      <legend className="px-1 mb-1 bg-white">
         <span className="text-sm font-medium text-gray-700">
            {label}
         </span>
        {required && <span className="text-red-500 ml-1">*</span>}
      </legend>
      <div className="relative">
        {leftIcon && (
          <div className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-400">
            {leftIcon}
          </div>
        )}
        <input
          id={inputId}
          ref={ref}
          className={cn(
            "w-full bg-transparent",
            "text-sm text-foreground",
            "outline-none border-none",
            "h-6 leading-none",
            "placeholder:text-muted-foreground",
            leftIcon ? "pl-7" : "pl-0",
            className
          )}
          {...props}
        />
      </div>
    </fieldset>
  );
});

InputFieldset.displayName = "InputFieldset";

export { InputFieldset };